import { useCallback } from 'react'
import { graphql, useMutation } from 'react-relay'

import {
  type useSetUserTermsAgreedMutation as UseSetUserTermsAgreedMutation,
  type useSetUserTermsAgreedMutation$data
} from '@/__generated__/useSetUserTermsAgreedMutation.graphql'

type CommitAsyncFn = () => Promise<useSetUserTermsAgreedMutation$data>

export const useSetUserTermsAgreedMutation = (): [CommitAsyncFn, boolean] => {
  const [commit, isPending] = useMutation<UseSetUserTermsAgreedMutation>(graphql`
    mutation useSetUserTermsAgreedMutation($input: SetUserTermsAgreedInput!) {
      setUserTermsAgreed(input: $input) {
        clientMutationId
        user {
          termsAgreedAt
          updatedAt
        }
      }
    }
  `)

  const commitAsync = useCallback<CommitAsyncFn>(
    () =>
      new Promise<useSetUserTermsAgreedMutation$data>((resolve, reject) =>
        commit({
          onCompleted: (response, errors) => {
            if (errors) {
              reject(errors)
            } else {
              resolve(response)
            }
          },
          // transport-level failures (offline, 5xx, WS drop) invoke onError, not onCompleted — without
          // this the promise would never settle and the caller would hang forever.
          onError: (error) => reject(error),
          variables: {
            input: {
              clientMutationId: 'setUserTermsAgreed'
            }
          }
        })
      ),
    [commit]
  )

  return [commitAsync, isPending]
}
